export default (client, defaultParams) => ({
  get: (hash) => (
    client(`/library/${hash}`, {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  all: () => (
    client('/libraries', {
      method: 'GET',
      params: {
        ...defaultParams,
      },
    })
  ),
  update: (hash, data) => (
    client(`/library/${hash}`, {
      method: 'PUT',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),
  create: (data) => (
    client('/libraries', {
      method: 'POST',
      data,
      params: {
        ...defaultParams,
      },
    })
  ),

  getMessage: (k) => {
    const messages = {
    };
    return (messages[k] || k);
  },
});
